var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('screen-card',{staticClass:"card-ephemeris",attrs:{"title":_vm.title}},[(_vm.data)?_c('p',{staticClass:"content"},[_vm._v(_vm._s(_vm.content))]):_c('p',{staticClass:"info-unavailable"},[_vm._v("Information indisponible")])])}
var staticRenderFns = []

export { render, staticRenderFns }